export default __webpack_public_path__ + "static/media/training.77d88a54.svg";